export const sizeSm = '0.8em';
export const sizeLg = '1.8em';
export const sizeXl = '3.0em';
export const sizeXxl = '7.5em';
export const sizeXxxl = '15em';
